var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box", attrs: { id: "cards" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", appear: "" } },
                    [
                      _c("DeploymentsGraph", {
                        attrs: {
                          metrics: _vm.metrics,
                          name: "Deployments",
                          date: _vm.date,
                          id: this.id
                        },
                        on: { updateMetric: _vm.updateMetric }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.displayBoards.length > 0 && _vm.activeType == "group"
                    ? _c("div", [
                        _c("div", { staticClass: "card" }, [
                          _c("h4", { staticClass: "card-heading" }, [
                            _vm._v("Contracts"),
                            _c("span", { staticClass: "board-count" }, [
                              _vm._v(_vm._s(_vm.displayBoards.length))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "dl",
                            [
                              _vm._l(_vm.displayBoards, function(contract) {
                                return [
                                  _c(
                                    "dt",
                                    {
                                      key: contract.contract,
                                      staticClass: "contracts",
                                      class: [
                                        {
                                          "hover-contract":
                                            _vm.hoverContract ==
                                            contract.contract
                                        },
                                        {
                                          "inactive-contract":
                                            _vm.hoverContract !=
                                            contract.contract
                                        }
                                      ],
                                      on: {
                                        mouseover: function($event) {
                                          _vm.hoverContract = contract.contract
                                        },
                                        mouseout: function($event) {
                                          _vm.hoverContract = null
                                        },
                                        click: function($event) {
                                          return _vm.updateContract(
                                            contract.contract
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(contract.contract))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    {
                                      key:
                                        contract.contract +
                                        contract.count.toString()
                                    },
                                    [_vm._v(_vm._s(contract.count))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.report.deployments.length > 0 &&
                  _vm.activeType == "contract"
                    ? _c("div", [
                        _c("div", { staticClass: "card" }, [
                          _c("h4", { staticClass: "card-heading" }, [
                            _vm._v("Stacks")
                          ]),
                          _vm._v(" "),
                          _c(
                            "dl",
                            [
                              _vm._l(_vm.displayStacks, function(deployment) {
                                return [
                                  _c(
                                    "dt",
                                    {
                                      key: deployment.stack_name,
                                      staticClass: "members-list",
                                      class: [
                                        {
                                          "active-member":
                                            _vm.activeStack ==
                                            deployment.stack_name
                                        },
                                        {
                                          "hover-member":
                                            _vm.hoverStack ==
                                              deployment.stack_name &&
                                            _vm.activeStack !=
                                              deployment.stack_name
                                        },
                                        {
                                          "inactive-member":
                                            _vm.activeStack !=
                                              deployment.stack_name &&
                                            _vm.hoverStack !=
                                              deployment.stack_name
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          return _vm.setActiveStack(
                                            deployment.stack_name
                                          )
                                        },
                                        mouseover: function($event) {
                                          _vm.hoverStack = deployment.stack_name
                                        },
                                        mouseout: function($event) {
                                          _vm.hoverStack = null
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(deployment.stack_name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    {
                                      key:
                                        deployment.stack_name +
                                        deployment.count.toString()
                                    },
                                    [_vm._v(_vm._s(deployment.count))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "vue-good-table",
              {
                attrs: {
                  columns: _vm.columns,
                  rows: _vm.filteredDeployments,
                  "search-options": {
                    enabled: true,
                    skipDiacritics: true,
                    placeholder: "Filter"
                  },
                  "pagination-options": { enabled: true, perPage: 20 },
                  styleClass: "vgt-table condensed"
                }
              },
              [
                _c("template", { slot: "table-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.downloadCSV()
                        }
                      }
                    },
                    [_vm._v("Download Report")]
                  )
                ])
              ],
              2
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eaf5d822", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eaf5d822","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CiinaboxDeployments.vue
// module id = null
// module chunks = 